import { Polygon, InfoWindow, Polyline } from '@react-google-maps/api';
import {
  boundMultiPolygon,
  clearPolygon,
  completePolygon,
  getBoundaryBox,
  getCentroidOfMultiplePolygons,
  isPolygonInvalid,
  removeEventManagedByLabel,
  showError,
  showPopUp,
  validateMaxVertices
} from '../../CommonUtilities/CommonUtilities';
import {
  MutableRefObject,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import {
  CursorIcon,
  RegisteredUser,
  SelectedRegisteredUser,
  SelectedTransportationIcon,
  TransportationIcon,
  VectorBlackIcon,
  VectorThemeIcon,
  mapCamera,
  locationIcon,
  mapConstruction,
  mapIncidents,
  mapRestFacilities,
  mapSpecialEvents,
  SelectedUser,
  MapCursor
} from '../../Universal/Assets';
import {
  camerasReceived,
  eventsReceived,
  getCameras,
  getEvents,
  getRestFacilities,
  restFacilitiesReceived
} from '../../Store/reducers/MapFilters';

import {
  LegendBox,
  ClosureMarker,
  MapWrapper,
  LegendButtonWrapper
} from './styles';
import { useReduxDispatch, useReduxSelector } from '../../Store/reduxHooks';
import dayjs from 'dayjs';
import {
  DrawControlButtonsWrapper,
  MapComponentWrapper
} from '../globalStyles';
import { Button, Icon, Switch } from '../../Universal/NovusDSImports';
import {
  btnStyles,
  switchStyles
} from '../../Universal/NovusDSImports/variants';
import { colorState } from '../../Universal/Foundation';
import LegendDropdownMenu from './FilterDropdownMenu';
import { STRINGS } from '../../Constants/ConstantStrings';
import { RootState } from '../../store';
import usePrevious from '../../Hooks/UsePrevious';
import { useClickOutside } from '../../Hooks/useClickOutside';
import PALoader from '../../SharedComponets/PALoader';
import { MILEPOSTS_API, TRAFFIC_API } from '../../settings';
import { MapFilterIntervalTime } from '../../Constants/constants';
import UserDetailsPopupModal from './UserDetailsPopupModal';
import CommonEventsTooltip from './LegendsTooltip/CommonEventsTooltip';
import RestFacilitiesPopUpWindow from './LegendsTooltip/RestFacilitiesTooltip';
import CameraTooltip from './LegendsTooltip/CameraTooltip';
import { TooltipComponent } from '../../SharedComponets/Tooltip';
import { PopupWindowContainer } from '../../SharedComponets/PopupWindow';

import Map from '../../SharedComponets/Map/Map';
import SearchField from '../../SharedComponets/Map/SearchField';
import { usePolygonDrawing } from '../../Hooks/UsePolygonDrawing';
import AdvancedMarker from '../../SharedComponets/Map/AdvancedMarker';

interface GoogleMapsComponentPropType {
  isDrawing: boolean;
  setDrawnPolygon: (polygon: any) => void;
  isEdit: boolean;
  drawnPolygon: any;
  showSideBar: boolean;
  setIsDrawing: (isDrawing: boolean) => void;
  isRegisteredUsers: boolean;
  mapCenter: { lat: number; lng: number };
  polygonRef: any;
  showClearButton: boolean;
  setShowClearButton: (show: boolean) => void;
  mapRef: MutableRefObject<google.maps.Map | null>;
  selectedMarker: number | null;
  setSelectedMarker: (marker: number | null) => void;
  selectedCard: any;
  isCloseEvent: boolean;
  registeredUsersLocation: any;
  setMapCenter: (center: { lat: number; lng: number }) => void;
  zoomLevel: number;
  isDropdownHeight?: any;
  setSelectedCard: (card: any) => void;
  selectedRegisteredUser: any;
  setselectedRegisteredUser: (user: any) => void;
  setZoomLevel: (level: number) => void;
  isCollapsableMap: boolean;
  setIsCollapsableMap: (isCollapsable: boolean) => void;
  isDrawMode: boolean;
  setIsDrawMode: (isDrawMode: boolean) => void;
  setAffectedAreaType: (type: string) => void;
  affectedAreaType: string;
  selectedRows: any;
  setSelectedRows: (rows: any) => void;
  setActiveTabName: (tabName: string | null) => void;
}

const GoogleMapsComponent = (props: GoogleMapsComponentPropType) => {
  const {
    isDrawing,
    setDrawnPolygon,
    drawnPolygon,
    showSideBar,
    setIsDrawing,
    isRegisteredUsers,
    isEdit,
    mapCenter,
    polygonRef,
    showClearButton,
    setShowClearButton,
    mapRef,
    selectedMarker,
    setSelectedMarker,
    selectedCard,
    isCloseEvent,
    registeredUsersLocation,
    setMapCenter,
    zoomLevel,
    setZoomLevel,
    setSelectedCard,
    selectedRegisteredUser,
    setselectedRegisteredUser,
    isCollapsableMap,
    setIsCollapsableMap,
    setIsDrawMode,
    isDrawMode,
    affectedAreaType,
    setAffectedAreaType,
    selectedRows,
    setSelectedRows,
    setActiveTabName
  } = props;

  const isMapLoaded = useReduxSelector(
    (state: RootState) => state.Common.isMapLoaded
  );

  const listenersRef = useRef<Array<google.maps.MapsEventListener>>([]),
    registeredUsersData = useReduxSelector(
      (state: RootState) => state.RegisteredUsers.registeredUsers
    ),
    selectedClosure = useReduxSelector(
      (state: RootState) => state.Common.selectedClosure
    ),
    [isSwitchSelected, setIsSwitchSelected] = useState<boolean>(false),
    [isLegendDropDown, setIsLegendDropdown] = useState<boolean>(false),
    [selectedUser, setSelectedUser] = useState<any>(null),
    [checkedItems, setCheckedItems] = useState<any>({
      cameras: false,
      mileposts: false,
      incidents: false,
      construction: false,
      specialEvents: false,
      restFacilities: false
    }),
    [mapViewBounds, setMapViewBounds] =
      useState<google.maps.LatLngBounds | null>(null),
    [isDragging, setIsDragging] = useState<boolean>(false),
    [selectedPolygonIndex, setSelectedPolygonIndex] = useState<number | null>(
      null
    ),
    prevCheckedItems = usePrevious(checkedItems),
    dispatch = useReduxDispatch(),
    cameras = useReduxSelector((state: RootState) => state.MapFilters.cameras),
    roadEvents = useReduxSelector(
      (state: RootState) => state.MapFilters.events
    ),
    currentUser = useReduxSelector(
      (state: RootState) => state.Common.currentUserDetails
    ),
    restFacilitiesData = useReduxSelector(
      (state: RootState) => state.MapFilters.restFacilities
    ),
    questionsclosuresData = useReduxSelector(
      (state: RootState) => state.Questions.closuresQuestionsData
    ),
    closuresData = useReduxSelector(
      (state: RootState) => state.Closures.closuresData
    ),
    selectedTab = useReduxSelector(
      (state: RootState) => state.Common.selectedTab
    ),
    isFetchingClosuresData = useReduxSelector(
      (state: RootState) => state.Closures.isFetchingClosureData
    ),
    isSubmitting = useReduxSelector(
      (state: RootState) => state.Closures.isSubmitting
    ),
    events = useReduxSelector((state: RootState) => state.MapFilters.events),
    eventMaintainers = useReduxSelector(
      (state: RootState) => state.Closures.eventMaintainers
    );

  const [searchMarker, setSearchMarker] = useState<any>(null);

  const [selectedCommonEvent, setSelectedCommonEvent] = useState<any>(null);
  const [isMapFullyReady, setIsMapFullyReady] = useState(false);

  const [isLoadingTiles, setIsLoadingTiles] = useState(false);
  const overlayLayerRefs = useRef<Record<string, google.maps.ImageMapType>>({});

  const [isStreetViewVisible, setIsStreetViewVisible] = useState(false);

  const streetViewListenerRef = useRef<google.maps.MapsEventListener | null>(
    null
  );

  const overlayImageGetters = {
    mileposts: (x: number, y: number, z: number) =>
      `${MILEPOSTS_API}${x}/${y}/${z}`,
    traffic: (x: number, y: number, z: number) =>
      `${TRAFFIC_API}?x=${x}&y=${y}&z=${z}`
  };

  const { isPointNearFirstPoint, handleDrawingCursorChange } =
    usePolygonDrawing({
      mapRef,
      isDrawing,
      isDrawMode
    });
  const getClosureMarkerPosition = (closure: any) => ({
    lat: getCentroidOfMultiplePolygons(closure?.geometry?.coordinates[0])[1],
    lng: getCentroidOfMultiplePolygons(closure?.geometry?.coordinates[0])[0]
  });

  const selectedClosureMarkerData =
    selectedMarker != null
      ? closuresData?.results?.find(
          (closure: any) => closure.id === selectedMarker
        )
      : null;

  const getPolygonOptions = useCallback(
    (isSelected?: boolean) => {
      const color = colorState.border.danger.primary;
      const isEditDrag =
        !isRegisteredUsers &&
        selectedTab !== 'eventDetails' &&
        !isSubmitting &&
        !isDrawMode &&
        !isDrawMode;
      const options = {
        fillColor: color,
        fillOpacity: 0.2,
        strokeWeight: isSelected ? 4 : 2,
        strokeColor: color,
        clickable: !isDrawMode && !isDrawMode,
        zIndex: 400,
        editable: isEditDrag,
        draggable: isEditDrag
      };
      return options;
    },
    [
      affectedAreaType,
      isRegisteredUsers,
      selectedTab,
      isSubmitting,
      selectedClosure,
      isDrawMode,
      isDrawing
    ]
  );

  const reArrangeIfMilepostLayer = (layerKey) => {
    const overlayLayerArray = mapRef.current?.overlayMapTypes.getArray();

    const milepostLayerIndex = overlayLayerArray?.findIndex(
      (layer) => layer?.name === 'mileposts'
    );

    const trafficLayerIndex = overlayLayerArray?.findIndex(
      (layer) => layer?.name === 'traffic'
    );

    if (
      (layerKey === 'traffic' &&
        milepostLayerIndex !== undefined &&
        milepostLayerIndex >= 0) ||
      (layerKey === 'mileposts' &&
        trafficLayerIndex !== undefined &&
        trafficLayerIndex >= 0)
    ) {
      mapRef.current?.overlayMapTypes.clear();
      mapRef.current?.overlayMapTypes.push(overlayLayerRefs.current['traffic']);
      mapRef.current?.overlayMapTypes.push(
        overlayLayerRefs.current['mileposts']
      );
    }
  };

  const handleLayerToggle = (
    isChecked: boolean,
    layerKey: 'mileposts' | 'traffic'
  ) => {
    const layerIndex = mapRef.current?.overlayMapTypes
      .getArray()
      ?.findIndex((layer) => layer?.name === layerKey);
    if (isChecked && layerIndex === -1) {
      overlayLayerRefs.current[layerKey] = new google.maps.ImageMapType({
        getTileUrl: function (coord: any, zoom: any) {
          setIsLoadingTiles(true);
          return overlayImageGetters[layerKey](coord.x, coord.y, zoom);
        },
        name: layerKey
      });
      overlayLayerRefs.current[layerKey].addListener('tilesloaded', () => {
        setIsLoadingTiles(false);
      });
      mapRef.current?.overlayMapTypes.push(overlayLayerRefs.current[layerKey]);
      reArrangeIfMilepostLayer(layerKey);
    } else if (typeof layerIndex === 'number' && layerIndex >= 0) {
      mapRef.current?.overlayMapTypes.removeAt(layerIndex);
    }
  };

  useEffect(() => {
    setIs90pointsErrorShown(false);
    setIsDrawMode(false);
    return () => {
      setDrawnPolygon(null);
    };
  }, [selectedClosure]);

  const handleFullScreenChange = () => {
    setSelectedUser(null);
    localStorage.setItem(
      'fullScreen',
      localStorage.getItem('fullScreen') === 'true' ? 'false' : 'true'
    );
  };

  useEffect(() => {
    let val: Array<string> = [];

    if (localStorage.getItem('legends')?.length) {
      val = JSON.parse(localStorage.getItem('legends') || '[]');

      const legendsObj = {
        cameras: val.includes('cameras'),
        mileposts: val.includes('mileposts'),
        incidents: val.includes('incidents'),
        construction: val.includes('construction'),
        specialEvents: val.includes('specialEvents'),
        restFacilities: val.includes('restFacilities')
      };

      setCheckedItems(legendsObj);
    } else {
      val = Object.keys(checkedItems).filter((key) => checkedItems[key]);

      localStorage.setItem('legends', JSON.stringify(val));
    }

    return () => {
      localStorage.removeItem('legends');
    };
  }, [checkedItems]);

  useEffect(() => {
    localStorage.setItem('fullScreen', 'false');
    window.addEventListener('fullscreenchange', handleFullScreenChange);
    return () => {
      localStorage.removeItem('fullScreen');
      window.removeEventListener('fullscreenchange', handleFullScreenChange);

      streetViewListenerRef.current?.remove();
      streetViewListenerRef.current = null;
    };
  }, []);

  useEffect(() => {
    Object.keys(overlayLayerRefs.current).forEach((layerKey) =>
      overlayLayerRefs.current[layerKey]?.setOpacity(isLoadingTiles ? 0 : 1)
    );
  }, [isLoadingTiles]);

  const handleSwitchToggle = (selected: boolean) => {
    if (mapRef.current) {
      handleLayerToggle(selected, 'traffic');
    }
    setIsSwitchSelected(selected);
  };
  const legendDropdown = () => {
      setIsLegendDropdown(!isLegendDropDown);
    },
    [selectedRestRoom, setSelectedRestRoom] = useState<any>(null);

  const [selectedCamera, setSelectedCamera] = useState<any>(null);
  const openStateElement = useRef(null);
  const excludedElement = useRef(null);

  useClickOutside(openStateElement, legendDropdown, [excludedElement]);

  const MarkerOpenStateRef = useRef(null);

  useClickOutside(MarkerOpenStateRef, () => {
    setSelectedMarker(null);
  });

  useEffect(() => {
    MarkerOpenStateRef.current = null;
    const streetViewCloseElement: any = document.querySelector('.gm-iv-close');
    streetViewCloseElement?.click();
  }, [isRegisteredUsers]);

  useEffect(() => {
    setSelectedMarker(null);
  }, [selectedTab]);

  useEffect(() => {
    setSelectedPolygonIndex(null);
  }, [selectedTab, selectedClosure, affectedAreaType, drawnPolygon]);

  const generateLegendBox = (color: string) => {
    return (
      <LegendBox className="legend-box" style={{ backgroundColor: color }} />
    );
  };

  const legendData = [
    {
      id: 1,
      legend_name: STRINGS.FREE_FLOWING,
      color: '#249D74'
    },
    {
      id: 2,
      legend_name: STRINGS.MODERATE_TRAFFIC,
      color: '#F4FF24'
    },
    {
      id: 3,
      legend_name: STRINGS.HEAVY_TRAFFIC,
      color: '#CC0004'
    },
    {
      id: 4,
      legend_name: STRINGS.STOP_AND_GO,
      color: '#4D0001'
    },
    {
      id: 5,
      legend_name: STRINGS.CLOSED,
      color: 'black'
    }
  ];

  const attachStreetViewListener = useCallback((map: google.maps.Map) => {
    streetViewListenerRef.current?.remove();

    const panorama = map.getStreetView();

    const updateStreetViewVisibility = () => {
      setIsStreetViewVisible(panorama.getVisible());
    };

    updateStreetViewVisibility();

    streetViewListenerRef.current = panorama.addListener(
      'visible_changed',
      updateStreetViewVisibility
    );
  }, []);

  const onMapLoad = useCallback(
    (map: google.maps.Map) => {
      mapRef.current = map;

      attachStreetViewListener(map);
      setTimeout(() => {
        setIsMapFullyReady(true);
      }, 200);

      if (isDrawing && isDrawMode) {
        map.setOptions({ draggableCursor: 'crosshair' });
      }
    },
    [isDrawing, isDrawMode]
  );

  useEffect(() => {
    if (!mapRef.current) return;

    mapRef.current.setOptions({
      draggableCursor: isDrawMode && isDrawing ? 'crosshair' : undefined,
      draggingCursor: isDrawMode && isDrawing ? 'crosshair' : undefined
    });
    if (!isDrawMode) {
      setHoverPoint(null);
    }
  }, [isDrawing, isDrawMode]);

  const getCompletePolygonPath = (polygonRef) => {
    const nextPath: any = [];
    polygonRef
      .getPath()
      .getArray()
      .forEach((latLng) => {
        nextPath.push([latLng.lat(), latLng.lng()]);
      });
    return completePolygon(nextPath);
  };

  const onEdit = useCallback(
    (index: number) => {
      if (polygonRef.current) {
        const newCompletePolygon = getCompletePolygonPath(
          polygonRef.current[index]
        );
        const data = drawnPolygon ? [...drawnPolygon] : [];
        const temp = [...drawnPolygon];
        data[index] = newCompletePolygon;
        if (handlePolygonValidations(newCompletePolygon, true, index))
          setDrawnPolygon(data);
        else {
          setDrawnPolygon(null);
          setDrawnPolygon(temp);
        }
      }
    },
    [polygonRef, setDrawnPolygon, drawnPolygon]
  );

  const onRemove = useCallback(
    (event: any, index: number) => {
      if (polygonRef.current) {
        const vertices = getCompletePolygonPath(polygonRef.current[index]);
        vertices.splice(event.vertex, 1);
        if (event.vertex === vertices?.length) {
          vertices.splice(0, 1);
          vertices.push(vertices[0]);
        }
        const data = drawnPolygon ? [...drawnPolygon] : [];
        if (vertices.length > 3) {
          data[index] = vertices;
          setDrawnPolygon(data);
        } else {
          data.splice(index, 1);
          // const refsData = polygonRef.current;
          // refsData.splice(index, 1);
          // polygonRef.current = [...refsData];
          setDrawnPolygon(data);
        }
      }
    },
    [polygonRef, drawnPolygon]
  );

  const stateBoundary = useReduxSelector(
    (state: RootState) => state.ClientInfo.state_boundary
  );

  const onPolygonLoad = useCallback(
    (polygon: google.maps.Polygon, index: number) => {
      // if (polygonRef.current) {
      //   polygonRef.current.setMap(null);
      // }
      polygonRef.current[index] = polygon;
      const path = polygon.getPath();
      listenersRef.current.push(
        path.addListener('set_at', () => onEdit(index)),
        path.addListener('insert_at', () => onEdit(index)),
        path.addListener('remove_at', () => onEdit(index))
      );
    },
    [onEdit, polygonRef]
  );

  useEffect(() => {
    if (
      isMapLoaded &&
      window.google &&
      selectedClosure &&
      ((drawnPolygon && selectedTab === 'edit_closures') || isCloseEvent)
    ) {
      let bounds;
      if (isCloseEvent) {
        bounds = boundMultiPolygon(selectedClosure?.geometry?.coordinates);
      } else {
        bounds = boundMultiPolygon([drawnPolygon]);
      }
      setMapViewBounds(bounds);
    }
  }, [selectedTab, selectedClosure, isCloseEvent, isMapLoaded, drawnPolygon]);

  useEffect(() => {
    if (isMapLoaded && window.google && drawnPolygon?.length && !isEdit) {
      const bounds = boundMultiPolygon([drawnPolygon]);
      setMapViewBounds(bounds);
    }
  }, [drawnPolygon, isMapLoaded, isEdit]);

  useEffect(() => {
    if (isMapLoaded && !closuresData?.results.length && stateBoundary) {
      const bounds = new window.google.maps.LatLngBounds(null);
      const boundary = getBoundaryBox(stateBoundary.coordinates);
      bounds.extend({ lat: boundary[1], lng: boundary[0] });
      bounds.extend({ lat: boundary[3], lng: boundary[0] });
      bounds.extend({ lat: boundary[3], lng: boundary[2] });
      bounds.extend({ lat: boundary[1], lng: boundary[2] });
      setMapViewBounds(bounds);
    }
  }, [closuresData, isMapLoaded, stateBoundary]);

  useEffect(() => {
    if (mapViewBounds) {
      mapRef.current?.fitBounds(mapViewBounds);
    }
  }, [mapRef, mapViewBounds]);

  const [drawingPolygon, setDrawingPolygon] = useState<Array<any>>([]);
  const [hoverPoint, setHoverPoint] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const [count, setCount] = useState(100);

  const isDraggingRef = useRef(false);

  const handlePolygonValidations = (
    polygonCoordsArray: any,
    isEdit?: boolean,
    index?: number
  ) => {
    if (stateBoundary?.coordinates) {
      const polygonInvalidError = isPolygonInvalid(
        polygonCoordsArray,
        true,
        stateBoundary?.coordinates
      );
      if (polygonInvalidError) {
        // handleClear();
        setCount(() => {
          const val = drawnPolygon?.reduce(
            (sum, polygon) => sum + polygon.length,
            0
          );

          return val ? 100 - val : 100;
        });
        setDrawingPolygon([]);
        showPopUp(polygonInvalidError, 'error');
        return false;
      }
      let data: any;
      if (isEdit) {
        data = drawnPolygon.map((polygon: any, i: number) => {
          if (i === index) {
            return polygonCoordsArray;
          } else {
            return polygon;
          }
        });
      }
      if (
        validateMaxVertices(
          isEdit
            ? data
            : drawnPolygon
            ? [...drawnPolygon, polygonCoordsArray]
            : [polygonCoordsArray]
        )
      ) {
        showPopUp(
          'You exceeded maximum vertices allowed. The last drawn point/polygon will be removed',
          'error'
        );
        return false;
      }
    } else {
      showError(STRINGS.SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN);
      return false;
    }
    return true;
  };
  const [is90pointsErrorShown, setIs90pointsErrorShown] = useState(false);

  useEffect(() => {
    const value = 100 - count;
    if (value > 100) {
      if (drawingPolygon.length) {
        setIsDrawMode(false);
        setIsDrawing(true);

        setCount(() => {
          const val = drawnPolygon?.reduce(
            (sum, polygon) => sum + polygon.length,
            0
          );

          return val ? 100 - val : 100;
        });
      }
    } else if (value >= 90) {
      if (!is90pointsErrorShown && isDrawing) {
        showPopUp(
          `You have used ${value} points. You can add ${
            100 - value
          } more points. Exceeding 100 points will result in the loss of your progress`,
          'info'
        );
        setIs90pointsErrorShown(true);
      }
    } else {
      setIs90pointsErrorShown(false);
    }
  }, [count, selectedClosure?.id]);

  useEffect(() => {
    if (drawnPolygon && drawnPolygon.length) {
      const val = drawnPolygon.reduce(
        (sum, polygon) => sum + polygon.length,
        0
      );

      setCount(100 - val);

      if (val > 100) {
        const newArr = [...drawnPolygon];
        newArr.pop();
        setDrawnPolygon([...newArr]);
      }
    } else {
      setCount(100);
    }
  }, [drawnPolygon]);

  useEffect(() => {
    setShowClearButton(drawnPolygon ? true : false);
    if (drawnPolygon?.length === 5) {
      setIsDrawMode(false);
    }
  }, [drawnPolygon, setShowClearButton]);

  const handleMapFilterClick = useCallback(() => {
    if (
      !prevCheckedItems ||
      (prevCheckedItems &&
        checkedItems['cameras'] !== prevCheckedItems['cameras'])
    ) {
      if (checkedItems['cameras']) {
        dispatch(camerasReceived({ cameras: null }));
        dispatch(getCameras({}));
        cameraIntervalId.current = setInterval(
          () => dispatch(getCameras({})),
          180000
        );
      } else {
        dispatch(camerasReceived({ cameras: null }));
        clearInterval(cameraIntervalId.current || '');
        cameraIntervalId.current = null;
      }
    }

    if (
      !prevCheckedItems ||
      (prevCheckedItems &&
        checkedItems['restFacilities'] !== prevCheckedItems['restFacilities'])
    ) {
      if (checkedItems['restFacilities']) {
        dispatch(restFacilitiesReceived({ restFacilities: null }));
        dispatch(getRestFacilities({}));
        restFacilitiesIntervalId.current = setInterval(
          () => dispatch(getRestFacilities({})),
          MapFilterIntervalTime
        );
      } else {
        dispatch(restFacilitiesReceived({ restFacilities: null }));
        clearInterval(restFacilitiesIntervalId.current || '');
        restFacilitiesIntervalId.current = null;
      }
    }
    if (
      !prevCheckedItems ||
      (prevCheckedItems &&
        (checkedItems['incidents'] !== prevCheckedItems['incidents'] ||
          checkedItems['construction'] !== prevCheckedItems['construction'] ||
          checkedItems['specialEvents'] !== prevCheckedItems['specialEvents']))
    ) {
      if (
        checkedItems['incidents'] ||
        checkedItems['construction'] ||
        checkedItems['specialEvents']
      ) {
        if (!events && !eventsIntervalId.current) {
          dispatch(eventsReceived({ events: null }));
          dispatch(getEvents({}));
          eventsIntervalId.current = setInterval(
            () => dispatch(getEvents({})),
            MapFilterIntervalTime
          );
        }
      } else {
        dispatch(eventsReceived({ events: null }));
        clearInterval(eventsIntervalId.current || '');
        eventsIntervalId.current = null;
      }
    }
  }, [checkedItems, events, prevCheckedItems]);

  const handleLegendsClear = () => {
    setCheckedItems({
      cameras: false,
      mileposts: false,
      incidents: false,
      construction: false,
      specialEvents: false,
      restFacilities: false
    });
    handleLayerToggle(false, 'mileposts');
  };

  useEffect(() => {
    handleMapFilterClick();
  }, [checkedItems, handleMapFilterClick]);

  useEffect(() => {
    return () => {
      if (cameraIntervalId.current) {
        clearInterval(cameraIntervalId.current);
        cameraIntervalId.current = null;
      }

      if (restFacilitiesIntervalId.current) {
        clearInterval(restFacilitiesIntervalId.current);
        restFacilitiesIntervalId.current = null;
      }

      if (eventsIntervalId.current) {
        clearInterval(eventsIntervalId.current);
        eventsIntervalId.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (selectedTab) {
      handleLegendsClear();
    }
  }, [selectedTab]);

  useEffect(() => {
    setSearchMarker(null);
  }, [selectedClosure, selectedTab]);

  useEffect(() => {
    setSelectedUser(
      selectedRegisteredUser
        ? registeredUsersData?.results?.indexOf(selectedRegisteredUser)
        : null
    );
  }, [selectedRegisteredUser, registeredUsersData]);

  const handleClear = useCallback(() => {
    if (polygonRef.current && selectedPolygonIndex === null) {
      polygonRef.current.map((polygon) => clearPolygon(polygon));
      polygonRef.current = [];
      setDrawnPolygon(null);
      setHoverPoint(null);
      setShowClearButton(false);
    }
    if (showSideBar && affectedAreaType === 'draw_polygon') {
      setIsDrawing(true);
    }
  }, [
    polygonRef,
    setDrawnPolygon,
    setIsDrawing,
    setShowClearButton,
    showSideBar,
    affectedAreaType,
    selectedPolygonIndex
  ]);

  const handleDeletePolygon = useCallback(() => {
    if (polygonRef.current && selectedPolygonIndex !== null) {
      const data = [...drawnPolygon];
      data.splice(selectedPolygonIndex, 1);
      setDrawnPolygon(data);
      setSelectedPolygonIndex(null);
    }
  }, [selectedPolygonIndex, drawnPolygon, setDrawnPolygon, polygonRef]);

  const cameraIntervalId = useRef<null | NodeJS.Timeout>(null),
    restFacilitiesIntervalId = useRef<null | NodeJS.Timeout>(null),
    eventsIntervalId = useRef<null | NodeJS.Timeout>(null);

  const getPolygonPath = (coords: Array<[number, number]>) => {
    return coords?.map((point) => ({ lat: point[0], lng: point[1] }));
  };

  const handleAddDrawingPoint = useCallback(
    (event: google.maps.MapMouseEvent) => {
      if (!isDrawing || !isDrawMode || !event.latLng) return;

      const nextPoint: [number, number] = [
        event.latLng.lat(),
        event.latLng.lng()
      ];

      setDrawingPolygon((prev) => {
        const next = [...prev, nextPoint];

        const savedVerticesCount =
          drawnPolygon?.reduce((sum, polygon) => sum + polygon.length, 0) || 0;

        const totalVertices = savedVerticesCount + next.length;

        setCount(100 - totalVertices);

        if (totalVertices > 100) {
          showPopUp(
            'You exceeded maximum vertices allowed. The last point will be removed',
            'error'
          );
          return prev;
        }

        return next;
      });
    },
    [isDrawing, isDrawMode, drawnPolygon]
  );

  const handleCompleteDrawing = useCallback(() => {
    if (!isDrawing || !isDrawMode) return;

    if (drawingPolygon.length < 3) {
      showPopUp(
        'Please add at least 3 points to complete the polygon',
        'error'
      );
      return;
    }

    const polygonCoordsArray = [...drawingPolygon, drawingPolygon[0]];

    if (!handlePolygonValidations(polygonCoordsArray)) return;

    const multi = drawnPolygon ? [...drawnPolygon] : [];
    multi.push(polygonCoordsArray);

    setDrawnPolygon(multi);
    setDrawingPolygon([]);
    setHoverPoint(null);
  }, [drawingPolygon, isDrawing, isDrawMode, drawnPolygon]);

  const handleDrawingMouseMove = useCallback(
    (event: google.maps.MapMouseEvent) => {
      if (!isDrawing || !isDrawMode || !event.latLng) {
        setHoverPoint(null);
        return;
      }

      const lat = event.latLng.lat();
      const lng = event.latLng.lng();

      handleDrawingCursorChange(lat, lng, drawingPolygon);

      setHoverPoint({
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      });
    },
    [isDrawing, isDrawMode, handleDrawingCursorChange, drawingPolygon]
  );

  const handleMapCursorClick = () => {
    if (isDrawMode) {
      setIsDrawMode(false);
      setDrawingPolygon([]);
      setHoverPoint(null);
      setCount(() => {
        const value = drawnPolygon?.reduce(
          (sum, polygon) => sum + polygon.length,
          0
        );

        return value ? 100 - value : 100;
      });
    }
  };

  if (isFetchingClosuresData) return <PALoader />;

  const popupWindow = (closure: any, user?: any) => {
    if (typeof closure === 'number') {
      closure = closuresData?.results.find(
        (closureData) => closureData.id === closure
      );
    }
    if (!closure) return <></>;

    return (
      <PopupWindowContainer
        ref={MarkerOpenStateRef}
        title={
          isRegisteredUsers ? STRINGS.USER_DETAILS : STRINGS.CLOSURE_DETAILS
        }
        onClose={() => {
          if (isRegisteredUsers) setSelectedUser(null);
          setSelectedMarker(null);
        }}
        closeAriaLabel={`Close ${
          isRegisteredUsers ? 'user details' : 'closure details'
        }`}
      >
        <h6>{closure.wea_short_msg_english}</h6>
        <div className="row latitude-longitude-section mx-0">
          <div className="col-sm-6 pe-1 ps-0">
            <label>
              {isRegisteredUsers
                ? STRINGS.LATITUDE
                : STRINGS.CENTER_POINT_LATITUDE}
            </label>
            <p>
              {isRegisteredUsers
                ? user?.location?.coordinates[0]
                : closure?.centre_latitude}
            </p>
          </div>
          <div className="col-sm-6 ps-1 pe-0">
            <label>
              {isRegisteredUsers
                ? STRINGS.LONGITUDE
                : STRINGS.CENTER_POINT_LONGITUDE}
            </label>
            <p>
              {isRegisteredUsers
                ? user?.location?.coordinates[1]
                : closure.centre_longitude}
            </p>
          </div>
        </div>

        {isRegisteredUsers && (
          <div className="group mt-3">
            <label htmlFor={`phone-${closure.id}`}>{STRINGS.PHONE}</label>
            <p id={`phone-${closure.id}`}>{user?.phone_number}</p>
          </div>
        )}
        {!isRegisteredUsers && (
          <div className="group mt-3">
            <label htmlFor={`condition-${closure.id}`}>
              {STRINGS.CURRENT_CONDITION}
            </label>
            <p id={`condition-${closure.id}`}>
              {isRegisteredUsers
                ? selectedClosure?.description
                : closure?.description}
            </p>
          </div>
        )}

        {!isRegisteredUsers && (
          <div className="group">
            <label htmlFor={`updated-${closure.id}`}>
              {STRINGS.UPDATED_ON}
            </label>
            <p id={`updated-${closure.id}`}>
              {' '}
              {dayjs(closure?.modified).format('MM/DD/YYYY  hh:mm A')}
            </p>
          </div>
        )}

        {isRegisteredUsers && (
          <div className="group">
            <label htmlFor={`contacted-${closure.id}`}>
              {STRINGS.LAST_CONTACTED_ON}
            </label>
            <p id={`contacted-${closure.id}`}>
              {user?.last_contacted_time
                ? dayjs(user?.last_contacted_time)?.format(
                    'MM/DD/YYYY  hh:mm A'
                  )
                : 'N/A'}
            </p>
          </div>
        )}
        {isRegisteredUsers &&
          questionsclosuresData &&
          questionsclosuresData.map((question: any) => {
            return (
              <div className="group" key={question.id}>
                <label htmlFor={`question-${question.id}-${closure.id}`}>
                  {question.display_name}
                </label>
                <p id={`question-${question.id}-${closure.id}`}>
                  {user?.answers && user?.answers[question.id]
                    ? user.answers && user.answers[question.id]
                    : 'N/A'}
                </p>
              </div>
            );
          })}
      </PopupWindowContainer>
    );
  };

  const onHandleClick = () => {
    setIsCollapsableMap(!isCollapsableMap);
  };

  const customStyles = {
    content: {
      minWidth: '300px',
      maxWidth: '400px',
      maxHeight: '50%'
    }
  };

  return (
    <>
      {isRegisteredUsers && (
        <div
          className={`${
            isRegisteredUsers && !isCollapsableMap && 'mb-2'
          } map-collapsable-wrapper`}
        >
          <div className="header">User Map</div>
          <div className="collapse-icon">
            <div
              data-tooltip-id="toggle-collapse"
              className={
                isCollapsableMap ? 'collapse-down-icon' : 'collapse-up-icon'
              }
            >
              <Icon
                icon={`${isCollapsableMap ? 'chevron_down' : 'chevron_up'}`}
                onClick={onHandleClick}
                width={20}
                height={20}
              />
            </div>
            <TooltipComponent id="toggle-collapse" place="left">
              {isCollapsableMap ? STRINGS.COLLAPSE : STRINGS.EXPAND}
            </TooltipComponent>
          </div>
        </div>
      )}

      <MapComponentWrapper
        id="map-wrapper"
        className={`${
          isRegisteredUsers
            ? isCollapsableMap
              ? 'register-users-map'
              : 'd-none'
            : ''
        }`}
        onMouseMove={() => {
          isDraggingRef.current = true;
        }}
        onClick={(e) => {
          if (isDrawing && isDrawMode && e.detail === 2) {
            handleCompleteDrawing();
          }
        }}
        isDrawing={
          isDrawing &&
          !(drawnPolygon?.length >= 5) &&
          affectedAreaType !== 'select_polygon'
        }
        isDeleteButton={selectedPolygonIndex !== null}
      >
        <Map
          id="closure-map"
          center={mapCenter}
          onLoad={onMapLoad}
          zoom={zoomLevel}
          onMouseDown={() => {
            isDraggingRef.current = false;
          }}
          onMouseMove={handleDrawingMouseMove}
          onClick={(event: google.maps.MapMouseEvent) => {
            event.stop();
            if (!isDraggingRef.current && isDrawing && isDrawMode) {
              if (!event.latLng) return;

              const lat = event.latLng.lat();
              const lng = event.latLng.lng();

              if (isPointNearFirstPoint(lat, lng, drawingPolygon)) {
                handleCompleteDrawing();
                return;
              }

              handleAddDrawingPoint(event);
            }
          }}
          onUnmount={() => {
            clearInterval(cameraIntervalId.current || '');
            clearInterval(restFacilitiesIntervalId.current || '');
            clearInterval(eventsIntervalId.current || '');
          }}
          containerStyle={{
            width: '100%',
            height: '100%'
          }}
          options={{
            mapTypeControl: !isSubmitting,
            streetViewControl: !isRegisteredUsers,
            disableDoubleClickZoom: isDrawing && isDrawMode,
            draggableCursor: isDrawMode ? 'crosshair' : undefined
          }}
        >
          <MapWrapper className="col-lg-6 col-xxl-10 ">
            {!isRegisteredUsers && !isStreetViewVisible && (
              <SearchField
                setMapCenter={setMapCenter}
                setZoomLevel={setZoomLevel}
              />
            )}

            {isDrawing &&
            !(drawnPolygon?.length >= 5) &&
            affectedAreaType !== 'select_polygon' ? (
              <DrawControlButtonsWrapper
                isDrawMode={isDrawMode}
                className="draw-control-buttons ms-lg-3 ms-xxl-0"
              >
                <div
                  onClick={handleMapCursorClick}
                  onKeyDown={(event: any) => {
                    if (event.key === 'Enter') {
                      handleMapCursorClick();
                    }
                  }}
                  aria-label="cursor-icon"
                  className={`${!isDrawMode && 'cursor-btn'} p-2 cursor-toggle`}
                  tabIndex={0}
                  data-tooltip-id="map-cursor"
                >
                  <TooltipComponent
                    id="map-cursor"
                    place="bottom-end"
                    tooltipBgColor="${colorState.surface.default['primary-inverse']}"
                    arrowColor="${colorState.surface.default['primary-inverse']}"
                  >
                    Map Cursor
                  </TooltipComponent>
                  <img
                    src={!isDrawMode ? MapCursor : CursorIcon}
                    alt={'cursor-img'}
                    className="map-cursor-icon"
                  />
                </div>
                <div
                  {...btnStyles.secondary}
                  onClick={() => {
                    setIsDrawMode(true);
                    setAffectedAreaType('draw_polygon');
                  }}
                  onKeyDown={(event: any) => {
                    if (event.key === 'Enter') {
                      setIsDrawMode(true);
                      setAffectedAreaType('draw_polygon');
                    }
                  }}
                  aria-label="draw-polygon"
                  className={`${
                    isDrawMode && 'draw-polygon-btn'
                  } p-2 cursor-toggle`}
                  tabIndex={0}
                  data-tooltip-id="create-shape"
                >
                  <TooltipComponent
                    id="create-shape"
                    place="bottom-start"
                    tooltipBgColor="${colorState.surface.default['primary-inverse']}"
                    arrowColor="${colorState.surface.default['primary-inverse']}"
                  >
                    Create Shapes
                  </TooltipComponent>

                  <img
                    src={isDrawMode ? VectorThemeIcon : VectorBlackIcon}
                    alt="vector-black-icon"
                  />
                </div>
              </DrawControlButtonsWrapper>
            ) : null}

            {showClearButton &&
            !isRegisteredUsers &&
            selectedTab !== 'eventDetails' &&
            selectedPolygonIndex === null &&
            drawnPolygon?.length ? (
              <div
                onClick={handleClear}
                className="polygon-clear-button"
                tabIndex={0}
              >
                {STRINGS.CLEAR}
              </div>
            ) : null}
            {selectedPolygonIndex !== null ? (
              <div
                role="button"
                className="polygon-delete-button"
                onClick={handleDeletePolygon}
                data-tooltip-id="delete-shape"
                tabIndex={0}
              >
                <Icon icon="trash_01" stroke="red" />
                <TooltipComponent id="delete-shape">
                  {STRINGS.DELETE_SELECTED_SHAPE}
                </TooltipComponent>
              </div>
            ) : null}

            {showSideBar ? (
              <div className="polygon-vertices-count text-nowrap ms-lg-2">
                <div className="coordinate-points">
                  {STRINGS.MAX_COORDINATES}
                </div>
                <div className="counter">{100 - count}/100</div>
              </div>
            ) : null}
          </MapWrapper>
          {checkedItems['cameras']
            ? cameras?.map((data: any, index: number) => (
                <AdvancedMarker
                  key={index}
                  onClick={() => {
                    if (selectedCamera && selectedCamera.Id === data.Id) {
                      setSelectedCamera(null);
                    } else {
                      setSelectedCamera(data);
                    }
                  }}
                  position={{ lat: data.latitude, lng: data.longitude }}
                >
                  <img src={mapCamera} alt="camera" />
                </AdvancedMarker>
              ))
            : null}

          {selectedCamera ? (
            <CameraTooltip
              camera={selectedCamera}
              setSelectedCamera={setSelectedCamera}
              markerOpenRef={MarkerOpenStateRef}
              setMapCenter={setMapCenter}
              setZoomLevel={setZoomLevel}
            />
          ) : null}

          {checkedItems['restFacilities']
            ? restFacilitiesData?.map((data: any, index: number) => {
                return (
                  <AdvancedMarker
                    key={index}
                    onClick={() => {
                      if (selectedRestRoom && selectedRestRoom.Id === data.Id) {
                        setSelectedRestRoom(null);
                      } else {
                        setSelectedRestRoom(data);
                      }
                    }}
                    position={{ lat: data.Latitude, lng: data.Longitude }}
                  >
                    <img src={mapRestFacilities} alt="restFacility" />
                  </AdvancedMarker>
                );
              })
            : null}

          {selectedRestRoom ? (
            <RestFacilitiesPopUpWindow
              markerOpenRef={MarkerOpenStateRef}
              restRoom={selectedRestRoom}
              setSelectedRestRoom={setSelectedRestRoom}
              setMapCenter={setMapCenter}
              setZoomLevel={setZoomLevel}
            />
          ) : null}

          {roadEvents?.map((event: any, index: number) => {
            if (
              (event.EventType === 'accidentsAndIncidents' &&
                checkedItems['incidents']) ||
              (event.EventType === 'roadwork' &&
                checkedItems['construction']) ||
              (event.EventType === 'specialEvents' &&
                checkedItems['specialEvents'])
            ) {
              return (
                <AdvancedMarker
                  key={index}
                  position={{
                    lat: event.Latitude,
                    lng: event.Longitude
                  }}
                  onClick={() => {
                    if (
                      selectedCommonEvent &&
                      selectedCommonEvent.ID === event.ID
                    ) {
                      setSelectedCommonEvent(null);
                    } else {
                      setSelectedCommonEvent(event);
                    }
                  }}
                >
                  <img
                    src={
                      event.EventType === 'accidentsAndIncidents'
                        ? mapIncidents
                        : event.EventType === 'roadwork'
                        ? mapConstruction
                        : mapSpecialEvents
                    }
                    alt={
                      event.EventType === 'accidentsAndIncidents'
                        ? 'mapIncidents'
                        : event.EventType === 'roadwork'
                        ? 'mapConstruction'
                        : 'mapSpecialEvents'
                    }
                  />
                </AdvancedMarker>
              );
            } else return <></>;
          })}

          {selectedCommonEvent ? (
            <CommonEventsTooltip
              markerOpenRef={MarkerOpenStateRef}
              commonEvent={selectedCommonEvent}
              setSelectedCommonEvent={setSelectedCommonEvent}
              setMapCenter={setMapCenter}
              setZoomLevel={setZoomLevel}
            />
          ) : null}

          {!isRegisteredUsers &&
          !showSideBar &&
          !isDrawing &&
          !isCloseEvent &&
          closuresData?.results.length
            ? closuresData?.results.map((closure: any, index: number) => {
                if (
                  !currentUser?.user_permission_set.role_names.includes(
                    'Admin'
                  ) &&
                  !currentUser?.user_permission_set.role_names.includes(
                    'Read Only Admin'
                  ) &&
                  currentUser?.user_permission_set.role_names.includes(
                    'IPAWS Admin'
                  ) &&
                  closure.alert_status === 'not_submitted'
                )
                  return <></>;
                const markerPosition = getClosureMarkerPosition(closure);
                return (
                  <ClosureMarker key={index} tabIndex={0}>
                    <AdvancedMarker
                      title={removeEventManagedByLabel(
                        closure.wea_short_msg_english,
                        eventMaintainers
                      )}
                      position={markerPosition}
                      onClick={() => {
                        setSelectedCard(closure);
                        setSelectedMarker(closure.id);
                      }}
                    >
                      <img
                        src={
                          selectedCard?.id === closure.id
                            ? SelectedTransportationIcon
                            : TransportationIcon
                        }
                        alt="closure-marker"
                        draggable={false}
                        className="closure-marker-target"
                      />
                    </AdvancedMarker>
                  </ClosureMarker>
                );
              })
            : null}

          {selectedMarker && selectedClosureMarkerData ? (
            <InfoWindow
              onCloseClick={() => {
                setSelectedMarker(null);
              }}
              position={getClosureMarkerPosition(selectedClosureMarkerData)}
            >
              {popupWindow(selectedMarker)}
            </InfoWindow>
          ) : null}

          {isRegisteredUsers
            ? registeredUsersData?.results?.map((user: any, index: number) => {
                if (
                  user.is_active &&
                  user.location &&
                  user.location.coordinates?.length
                ) {
                  return (
                    <AdvancedMarker
                      key={user.id}
                      position={{
                        lat: user.location.coordinates[0],
                        lng: user.location.coordinates[1]
                      }}
                      onClick={() => {
                        setselectedRegisteredUser(user);
                        setSelectedUser(index);
                        if (!(selectedRows && selectedRows[index])) {
                          setActiveTabName(null);
                          const data = { ...selectedRows };
                          data[index] = true;
                          setSelectedRows(data);
                        }
                      }}
                    >
                      <img
                        className="registered-user-marker"
                        src={
                          selectedRegisteredUser?.id === user.id
                            ? SelectedRegisteredUser
                            : selectedRows && selectedRows[index]
                            ? SelectedUser
                            : RegisteredUser
                        }
                        alt="user-marker"
                        draggable={false}
                      />

                      {localStorage.getItem('fullScreen') !== 'true' ? (
                        <UserDetailsPopupModal
                          isOpen={selectedUser === index}
                          selectedClosure={selectedClosure}
                          userDetails={user}
                          setSelectedUser={setSelectedUser}
                          style={customStyles}
                          isBodyPaddingNone
                        />
                      ) : (
                        selectedUser === index && (
                          <InfoWindow
                            onCloseClick={() => setSelectedUser(null)}
                            position={{
                              lat: user.location.coordinates[0],
                              lng: user.location.coordinates[1]
                            }}
                          >
                            {popupWindow(selectedClosure, user)}
                          </InfoWindow>
                        )
                      )}
                    </AdvancedMarker>
                  );
                }
                return <></>;
              })
            : null}

          {isCloseEvent && registeredUsersLocation
            ? registeredUsersLocation?.map((user, index: number) => {
                return (
                  <AdvancedMarker
                    key={index}
                    position={{
                      lat: user.location[1],
                      lng: user.location[0]
                    }}
                  >
                    <img
                      src={RegisteredUser}
                      alt="Registered User"
                      style={{
                        transform: 'translate(-50%, -100%)'
                      }}
                    />
                  </AdvancedMarker>
                );
              })
            : null}

          {isCloseEvent
            ? selectedClosure?.geometry?.coordinates[0].map((polygon) => (
                <Polygon
                  path={getPolygonPath(polygon)}
                  options={{
                    strokeWeight: 2,
                    fillColor: 'red',
                    fillOpacity: 0.2,
                    strokeColor: 'black',
                    zIndex: 400
                  }}
                />
              ))
            : null}

          {isDrawing && isDrawMode && drawingPolygon.length > 0 && (
            <Polyline
              path={
                hoverPoint
                  ? [...getPolygonPath(drawingPolygon), hoverPoint]
                  : getPolygonPath(drawingPolygon)
              }
              options={{
                strokeColor: colorState.border.danger.primary,
                strokeOpacity: 1,
                strokeWeight: 2,
                clickable: false,
                editable: false,
                draggable: false,
                zIndex: 450
              }}
            />
          )}

          {drawnPolygon
            ? drawnPolygon.map((polygon, index) => (
                <Polygon
                  onLoad={(polygon) => {
                    onPolygonLoad(polygon, index);
                  }}
                  path={getPolygonPath(polygon)}
                  options={getPolygonOptions(selectedPolygonIndex === index)}
                  onMouseUp={(event: any) => {
                    if (
                      event.path === undefined &&
                      event.vertex === undefined &&
                      event.edge === undefined
                    ) {
                      return;
                    }
                    onEdit(index);
                  }}
                  onDragStart={() => {
                    setIsDragging(true);
                  }}
                  onDragEnd={() => {
                    setIsDragging(false);
                    onEdit(index);
                  }}
                  onRightClick={(event: any) => {
                    if (isDrawMode) {
                      event?.preventDefault();
                      return;
                    } else if (!(event.vertex || event.vertex === 0)) {
                      return;
                    }
                    onRemove(event, index);
                  }}
                  onClick={() => {
                    if (showSideBar) {
                      if (selectedPolygonIndex === index)
                        setSelectedPolygonIndex(null);
                      else setSelectedPolygonIndex(index);
                    }
                  }}
                />
              ))
            : null}

          {/* Polygon to highlight PA state */}
          {/* <Polygon
          path={convertGeoJSONToLatLng(PAStateBoundary)}
          options={{ strokeWeight: 4, fillOpacity: 0 }}
        /> */}

          {!isDragging &&
          !isCloseEvent &&
          showClearButton &&
          !isRegisteredUsers &&
          selectedTab !== 'eventDetails' &&
          !isSubmitting
            ? drawnPolygon?.map((polygon) =>
                getPolygonPath(polygon)?.map((vertex, index) => {
                  return (
                    <AdvancedMarker
                      key={index}
                      position={vertex}
                      title="Drag to change, Right click to remove the vertex"
                    >
                      <div className="vertex-marker">
                        {index !== getPolygonPath(polygon).length - 1
                          ? index + 1
                          : 1}
                      </div>
                    </AdvancedMarker>
                  );
                })
              )
            : null}

          {!isRegisteredUsers ? (
            <ul className="custom-legend-wrapper">
              <li>
                {STRINGS.TRAFFIC}
                <Switch
                  className="switch-styles"
                  accessibleText={true}
                  accessibleTextColor={colorState.text.primary}
                  selected={isSwitchSelected}
                  onClick={handleSwitchToggle}
                  {...switchStyles}
                />
              </li>
              {isSwitchSelected &&
                legendData?.map((item: any, index: number) => {
                  return (
                    <li key={index}>
                      {item.legend_name === 'Closed' ? (
                        <hr className="dashed"></hr>
                      ) : (
                        <span>{generateLegendBox(item.color)}</span>
                      )}
                      <span>{item.legend_name}</span>
                    </li>
                  );
                })}
            </ul>
          ) : null}
          {!isRegisteredUsers && (
            <LegendButtonWrapper
              isMapFullyReady={isMapFullyReady}
              className="filter-btn"
              ref={excludedElement}
            >
              <Button
                {...btnStyles.secondary}
                onClick={legendDropdown}
                aria-label="legend-dropdown"
              >
                <Icon
                  icon="filters"
                  className="mr-3"
                  stroke={`${colorState.icon.brand.primary}`}
                ></Icon>
                {STRINGS.LEGEND}
              </Button>
              {isLegendDropDown && (
                <div ref={openStateElement}>
                  <LegendDropdownMenu
                    isDropdownHeight={props.isDropdownHeight}
                    checkedItems={checkedItems}
                    setCheckedItems={setCheckedItems}
                    setIsLegendDropDown={setIsLegendDropdown}
                    handleLayerToggle={handleLayerToggle}
                    handleClear={handleLegendsClear}
                  />
                </div>
              )}
            </LegendButtonWrapper>
          )}
        </Map>
      </MapComponentWrapper>
    </>
  );
};
export default GoogleMapsComponent;
